import type { UiNode, UiNodeInputAttributes } from '@ory/client';
import { ORDER as BUTTON_ORDER } from './Input/Button';
import { ORDER as CHECKBOX_ORDER } from './Input/Checkbox';
import { ORDER as DEFAULT_ORDER } from './Input/Default';
import { ORDER as EMAIL_ORDER } from './Input/Email';
import { ORDER as HIDDEN_ORDER } from './Input/Hidden';
import { ORDER as OTP_ORDER } from './Input/OneTimePassword';
import { ORDER as PASSWORD_ORDER } from './Input/Password';
import { ORDER as RESEND_ORDER } from './Input/Resend';
import { ORDER as SUBMIT_ORDER } from './Input/Submit';
import { ORDER as TEXT_ORDER } from './Input/Text';

/**
 * 各InputコンポーネントのORDER定数を集約したマップ
 * InputNode/index.tsxのディスパッチロジックと対応
 */
const INPUT_ORDER_MAP = {
  hidden: HIDDEN_ORDER,
  text: TEXT_ORDER,
  email: EMAIL_ORDER,
  password: PASSWORD_ORDER,
  checkbox: CHECKBOX_ORDER,
  button: BUTTON_ORDER,
  submit: SUBMIT_ORDER,
  // 特殊ケース
  resend: RESEND_ORDER,
  // name="resend" の submit
  otp: OTP_ORDER,
  // name="totp_code" or "code" の text
  default: DEFAULT_ORDER
} as const;

/**
 * その他のノードタイプの表示順序
 */
const OTHER_NODE_ORDER = {
  text: 50,
  img: 50,
  script: 50
} as const;

/**
 * UiNodeの表示順序を取得する
 * 各Inputコンポーネントに定義されたORDER定数を参照
 */
/**
 * 再送ボタンとして扱うname属性のリスト
 */
const RESEND_NAMES = ['resend', 'resend_code', 'email'] as const;
export function getNodeOrder(node: UiNode): number {
  switch (node.type) {
    case 'input':
      {
        const attrs = node.attributes as UiNodeInputAttributes;

        // resendボタンは特別な順序
        const isResendButton = attrs.type === 'submit' && RESEND_NAMES.includes(attrs.name as (typeof RESEND_NAMES)[number]);
        if (isResendButton) {
          return INPUT_ORDER_MAP.resend;
        }

        // OTP入力フィールドは特別な順序
        if (attrs.type === 'text' && (attrs.name === 'totp_code' || attrs.name === 'code')) {
          return INPUT_ORDER_MAP.otp;
        }

        // その他のinputタイプ
        const inputType = attrs.type as keyof typeof INPUT_ORDER_MAP;
        return INPUT_ORDER_MAP[inputType] ?? INPUT_ORDER_MAP.default;
      }
    case 'text':
      return OTHER_NODE_ORDER.text;
    case 'img':
      return OTHER_NODE_ORDER.img;
    case 'script':
      return OTHER_NODE_ORDER.script;
    default:
      return 50;
  }
}